import { render, staticRenderFns } from "./navMessaging.vue?vue&type=template&id=1c157526&scoped=true"
import script from "./navMessaging.vue?vue&type=script&lang=js"
export * from "./navMessaging.vue?vue&type=script&lang=js"
import style0 from "./navMessaging.vue?vue&type=style&index=0&id=1c157526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c157526",
  null
  
)

export default component.exports